<template>
    <div>
        <label class="control-label">{{ $t('labelStatistic') }}</label>
        <div class="btn-group float-right">
            <b-button :id="'btnRefresh'"
                      :name="'btnRefresh'"
                      class="btn btn-default btn-glyphicon"
                      variant="outline-dark"
                      :title="$t('refresh')"
                      @click="$_refreshStatistics()"
                      :disabled="statisticsUser == null || statisticsUser.length == 0">
                <span class="fas fa-redo-alt" v-bind:class="{ 'fas fa-redo-alt fas fa-redo-alt': !statisticsLoaded && btnRefreshPressed }"></span>
            </b-button>
            <CsvExport :disabled="statisticsUser == null || statisticsUser.length == 0"
                       :dataArray="csvData"
                       :fileName="'statistiek_gebruikstijd.csv'"
                       :fieldSeparator="';'"
                       :title="$t('labelDownloadStats')">
            </CsvExport>
        </div>
        <b-badge variant="primary" v-show="!statisticsLoaded">{{ $t('loading') }}</b-badge>
        <b-table striped
                 hover
                 small
                 outlined
                 bordered
                 v-show="statisticsLoaded"
                 :tbody-tr-class="$_rowClass"
                 :items="statisticsUser"
                 :fields="fields">
        </b-table>
        <div v-if="noItemsFound">{{ $t('noResultsFound') }}</div>
    </div>
</template>
<script>
    import CsvExport from '../../components/CsvExport.vue';

    export default {
        name: 'StatisticsUser',

        components: { CsvExport, },

        data: function () {
            return {
                userInfo: {},
                statisticsLoaded: true,
                statisticsUser: [],
                organizationId: null,
                userId: null,
                btnRefreshPressed: false,
                fields: [
                    {
                        key: 'year',
                        label: this.$t('labelYear'),
                        sortable: false,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'month',
                        label: this.$t('labelMonth'),
                        sortable: false,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'time',
                        label: this.$t('labelTimeMinutes'),
                        sortable: false,
                        thStyle: { border: 0 }
                    }
                ]
            };
        },

        created() {
            this.userInfo = this.$store.getters.userInfo;
        },

        computed: {
            csvData() {
                return this.statisticsUser.map(item => ({
                    Jaar: item.year,
                    Maand: item.month,
                    Tijd: item.time
                }));
            },

            noItemsFound: function () {
                return this.statisticsUser === null || this.statisticsUser !== null && this.statisticsUser.length === 0;
            },
        },

        methods: {
            $_rowClass() {
                return 'tablerow';
            },

            /**
              * Refresh-button is pressed
              */
            $_refreshStatistics: function () {
                this.btnRefreshPressed = true;
                this.$_loadStatistics(this.organizationId, this.userId);
            },

            /**
              * Get all statistics for specified organization or user
              * @param  {[type]} $event het event
              * @param  {[type]} organizationId selected organization
             */
            getStatisticsUserByUserId: function (organizationId, userId) {
                this.$_loadStatistics(organizationId, userId);
            },

            /**
             * Get all statistics for specified organization/user from database
             * @param  {[type]} organizationId selected organization
             * @param  {object} userId selected user
             */
            $_loadStatistics: function (organizationId, userId) {
                if (userId) {
                    this.userId = userId;
                    this.organizationId = null;
                    this.$_getDataStatistics('GetUserByUserId', { userId: userId });
                } else if (organizationId) {
                    this.organizationId = organizationId;
                    this.userId = null;
                    this.$_getDataStatistics('GetUserByOrganizationId', { organizationId: organizationId });
                } else {
                    this.organizationId = null;
                    this.userId = null;
                    this.$_getDataStatistics('GetUserAll', null);
                }
            },

            async $_getDataStatistics(name, parameters) {
                this.statisticsLoaded = false;
                const result = await this.$store.dispatch('useApiData', {
                    name,
                    parameters
                });
                this.statisticsUser = result?.data;
                this.statisticsLoaded = true;
                this.btnRefreshPressed = false;
            }
        }
    };
</script>
